<div class="tw-flex tw-items-center tw-justify-between tw-leading-4 tw-px-4 tw-py-2 tw-uppercase">
  <i
    (click)="prevMonth()"
    class="fas fa-chevron-left"
  ></i>
  <label for="">{{ month }}</label>
  <i
    (click)="nextMonth()"
    class="fas fa-chevron-right"
  ></i>
</div>
<div class="calendar expand{{ this.side }}">
  <table class="tw-w-full tw-text-center tw-border-collapse">
    <tr>
      <th
        *ngFor="let weekday of weekdayNames"
        class="tw-text-gray-500"
      >
        {{ weekday }}
      </th>
    </tr>
    <tr *ngFor="let week of days">
      <td
        *ngFor="let day of week"
        (mouseenter)="hoverDate(day)"
        (click)="updateDate(day)"
        [class.current]="day.current"
        [class.start]="day.start"
        [class.end]="day.end"
        [class.range]="day.range"
        [class.expand]="day.expand"
        [class.today]="day.today"
        [class.unavailable]="!day.available"
        [class.readonly]="readonly"
      >
        {{ day.number }}
      </td>
    </tr>
  </table>
</div>
